export default __webpack_public_path__ + "static/media/halftone_gerjan.09874ea4.png";